module.exports = __webpack_public_path__ + "img/icon-send-money-now.b9a1e6da.svg";